import React, { useState } from 'react';
import { BackArrow } from "../../shared/svgIcons.jsx";
import styled from '@emotion/styled';


const Header = styled.h3`
  font-family: 'OCRoboto';
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 22px;
  padding-top: 1rem;
  text-transform: none;
`;


export default () => {

  return (<div>
    <p>No email address? No problem! One of our representatives would be happy to help you. Simply give us a call us at</p>
    <Header>1-800-ROOFING</Header>
    </div>
  )

}
